import React from 'react';
import {Link} from 'react-router-dom';
import workoutItemStyle from '../style';

export default function Workout({name, routeName, subtext, addonClasses, showLinks = true, addonStyle = {}, thumbnail}) {
	let style = workoutItemStyle();

	let links = () => {
		if (showLinks) {
			return (
				<>
					<Link style={style.buttonText()} to={`/${routeName}`}>
						Start
					</Link>
					<Link style={style.learnMoreText()} to={`/${routeName}`}>
						Learn more
					</Link>
				</>
			);
		}
		return <> </>;
	};

	return (
		<div
			className={addonClasses}
			style={{
				...style.workoutItem(thumbnail),
				...addonStyle,
			}}
		>
			<section style={style.workoutContentsContainer()}>
				<h4 style={style.titleText()}>{name}</h4>
				<h6 style={style.subtitleText()}>{subtext}</h6>
				{links()}
			</section>
		</div>
	);
}
